import { each } from 'lodash';

// Expand and collapse a row when needed
export function toggleQuestionCollapse(element) {
  const target = $(element).parents('.bipolar-vertical');
  const answersDiv = $(target).find('.bipolar-vertical-wrapper');
  if (answersDiv.hasClass('bipolar-vertical-wrapper--closed')) {
    answersDiv.removeClass('bipolar-vertical-wrapper--closed').slideDown();
    target.removeClass('bipolar-vertical--closed');
  } else {
    answersDiv.addClass('bipolar-vertical-wrapper--closed').slideUp();
    target.addClass('bipolar-vertical--closed');
  }
  // The check icon should be visible only
  // when a column is selected and the row is collapsed
  if (
    target.hasClass('bipolar-vertical--closed') &&
    target.hasClass('answerClick')
  ) {
    target.addClass('bipolar-vertical--checked');
  } else {
    target.removeClass('bipolar-vertical--checked');
  }
}

export function onScrollDownMessage() {
  let hasEmptyAnswer = false;
  each($('.answer--bipolar'), (answerElement) => {
    if (!$(answerElement).attr('data-selected-column-id')) {
      hasEmptyAnswer = true;
    }
  });

  if (
    !hasEmptyAnswer &&
    !$('[data-btn="submit-btn"]').isOnScreen() &&
    Pollfish.helper.flag.showScrollDownMsg
  ) {
    Pollfish.helper.flag.showScrollDownMsg = false;
    Pollfish.ui.prompt(Pollfish.ui.getText('scroll_down'));
  }
}
